import React, {useState} from "react";
import PropTypes from 'prop-types';
import {Collapsible, ResourceList, Thumbnail, TextStyle, Card, Heading, ResourceItem } from "@shopify/polaris";
import TransferShow from "@presentational/transfer/TransferShow";

const propTypes ={
  product: PropTypes.object.isRequired,
  symbol: PropTypes.string.isRequired
}
const LogItem=({product, symbol})=>{
  const [open, setOpen] = useState(false);
  const onItemClick = () => {
    setOpen(!open)
  }

  return(
    <ResourceItem
      id={product.id}
      url={""}
      external
      onClick={ onItemClick }
    >
      <div className="MainLogs flex justifyBetween">
          <div className="flex alignItemsCenter">
           <Thumbnail source={product.variant.image_url} alt={product.variant.display_name} />
            <div className="ml10">
              <TextStyle variation="strong">{product.variant.display_name}</TextStyle><br/>
              <TextStyle variation="subdued"> {product.variant.sku} <br/>{product.goods_moved_logs.length} logs registrados</TextStyle><br/>
              { product.bright_pearl_id ?
                <TextStyle variation="code">Item ID: { product.bright_pearl_id }</TextStyle>
              :
                <TextStyle variation="negative">El producto aún no está sincronizado con el PO</TextStyle>
              }
            </div>
          </div>
          <div className="text-right">
            <p>Cantidad: {product.quantity}</p>
            <p>{symbol} {product.unit_cost}</p>
          </div>
      </div>

      <div className='logs mt10'>
        <Collapsible
          open={open}
          id="basic-collapsible"
        >
          { product.goods_moved_logs.length > 0 ?
            <div >
              <div className="row headerLogs">
                <div className="col-md-6 Polaris-DataTable__Cell Polaris-DataTable__Cell--header">
                  <Heading>Cantidad recibida: { product.shipped }</Heading>
                </div>
                <div className="col-md-6  Polaris-DataTable__Cell Polaris-DataTable__Cell--header">
                  <Heading>Cantidad vendida: { product.quantity_sold }</Heading>
                </div>
              </div>
              <div className="flex flexColumn flexColumnReverse mb10">
                { product.goods_moved_logs.map((pl)=>{
                    return(
                      <div id={pl.id} key= {pl.id} className="mb10">
                        <div className="row fmalign Polaris-DataTable__Cell">
                          <div className="col-md-6">
                            <TextStyle >
                              { I18n.t(`enum.kind.${pl.kind}`)} {pl.status == "confirmed" ? "+ " : "- "}
                              {pl.quantity}
                            </TextStyle>
                            <br/>
                            <TextStyle variation="subdued" >
                              ID: { pl.goods_note_id }
                            </TextStyle>
                          </div>
                          <div className="col-md-6 text-right">
                            <TextStyle>
                              {I18n.t(`enum.status.${pl.status}`)}
                            </TextStyle><br/>
                            <TextStyle >
                              {pl.human_created_at_text}
                            </TextStyle>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
                : <p>Aún no se ha registrado ningún movimiento en la Entrega APU para este producto.</p>
              }
        </Collapsible>
      </div>

    </ResourceItem>
  )

}

LogItem.propTypes = propTypes;
export default  LogItem
